import {Component, OnInit, OnDestroy, ViewChild, Input} from '@angular/core';
import { Subject } from 'rxjs';
import {take, takeUntil} from 'rxjs/operators';
import { ProductMappingService } from '../../../api/product-mapping.api';

import {GridSetting, GridSettings, GridState, User} from '../../../shared';
import {
	ProductMappingGridModel, ProductMappingToMasterGridResult,
} from '../../../shared/models/product.model';
import CustomStore from 'devextreme/data/custom_store';
import { ExtraFilteringOptions, FilterOperationModel, LoadOptions, SearchNestedList } from '../../../shared/models/shared.model';
import { DxDataGridComponent, DxSelectBoxComponent } from 'devextreme-angular';
import { UserApi } from '../../../api';
import { MappingAction, MappingMode } from '../../../shared/enum/mapping-mode.enum';
import { BarcodeMappingOption, ProductMappingOption } from '../../../shared/models/product-mapping-option';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import 'devextreme/integration/jquery';
import * as moment from 'moment';
import { DragulaService } from 'ng2-dragula';
import { LoaderService } from '../../../core/loader/loader.service';
import { NotificationService } from '../../../service/notification.service';
import { NotificationType } from '../../../shared/enum/notification.enum';
import {ProductEditComponent} from './product-edit/product-edit.component';
import {FilterBuilderService} from '../../../service/filter-builder.service';

@Component({
	selector: 'product-mapping',
	templateUrl: 'product-mapping.component.html',
	styleUrls: ['product-mapping.component.css']
})

export class ProductMappingComponent implements OnInit, OnDestroy {
  @ViewChild('productMappingDataGrid') productMappingDataGrid: DxDataGridComponent; // the first grid
  @ViewChild('productToMasterGrid') productToMasterGrid: DxDataGridComponent; // middle grid
  @ViewChild('productMasterDataGrid') productMasterDataGrid: DxDataGridComponent; // the third grid

  @ViewChild('companySelectBox') companySelectBox: DxSelectBoxComponent;
  @ViewChild('masterBrandSelectBox') masterBrandSelectBox: DxSelectBoxComponent;
  @ViewChild('brandSelectBox') brandSelectBox: DxSelectBoxComponent;
  @ViewChild('subBrandSelectBox') subBrandSelectBox: DxSelectBoxComponent;
  @ViewChild('productSelectBox') productSelectBox: DxSelectBoxComponent;

	@Input() cleanBarcode: string;
	@Input() isModal = false;

  public productToMasterData: ProductMappingToMasterGridResult[] = [];
  public productMappingDataSource: any = {};
  public currentUser: User;
  public productMappingSelectedRowData: ProductMappingGridModel; // first grid selected row

  public extraFilteringOptions: ExtraFilteringOptions[] = [
		{ column: 'Active', value: false },
	{ column: 'SourceCategoryIsExcluded', value: false },
	{ column: 'SourceCompanyIsExcluded', value: false },
	{ column: 'SourceMasterBrandIsExcluded', value: false },
  ];

  public selectedMasterGridRow: any;

  public mappingAssignedHeaderDataSource;
  public modifiedByHeaderDataSource;
  public reviewedByHeaderDataSource;
  public createdByHeaderDataSource;
  public mappingModeNameHeaderDataSource;
  public masterBrandNameMappingHeaderDataSource;
  public brandNameMappingHeaderDataSource;
  public companyNameMappingHeaderDataSource: any;
  public categoryNameMappingHeaderDataSource;
  public mappingPriorityHeaderDataSource;

  public modifiedOnHeaderDataSource;
  public reviewedOnHeaderDataSource;
  public createdOnHeaderDataSource;

  public mappingDataGridCurrentPage: number;
  // productMappingDataSourceHolder: { data: any; totalCount: any; summary: any; groupCount: any; };
  public productMappingLoadingOptions: LoadOptions;

  private _destroyed$ = new Subject();
  private _editCanceled$ = new Subject();
  private isMoveToNextRow = false;
  private productMappingSelectedRowIndex: number;
  private isProductMappingDataLoading = false;
  private isProductToMasterGridDataLoading = false;
  private isProductMasterDataLoading = false;
  public isLoadProductMappingGridDataSource: boolean;
  public isLoadProductMasterGridDataSource: boolean;
  private readonly mappingGridName: string = 'productMappingDataGrid';
  private readonly pageName: string = 'productMapping';
  private currentProductMappingDataGridState: GridState;
  private productMappingDataGridSettings: GridSettings;
  private productMasterDataGridSettings: GridSettings;
  private isProductMappingDataGridSettingLoading = true;
  private isProductMasterDataGridSettingLoading = true;
  private productMappingDataGridSetting: GridSetting = new GridSetting();
  private productMasterDataGridSetting: GridSetting = new GridSetting();
	public isCreateProduct: boolean;

  constructor(
	private productMappingService: ProductMappingService,
	private userService: UserApi,
	private modalService: NgbModal,
	public dragulaService: DragulaService,
	private loaderService: LoaderService,
	private notificationService: NotificationService,
	private filterBuilder: FilterBuilderService) {
		dragulaService.createGroup('HANDLES', {
		moves: (el, container, handle) => {
			return handle.className === 'fa fa-arrows';
		}
		});
	}

  ngOnInit() {
	this.loaderService.show();
	this.currentUser = this.userService.logonUser;
	if (!this.currentUser) {
		return;
	}
	this.productMappingDataGridSettings = {
		PageName: this.pageName,
		GridName: this.mappingGridName,
		OwnedByUserId: this.currentUser.UserId
	};
	this.userService.getGridSettings(this.productMappingDataGridSettings)
		.pipe(take(1))
		.subscribe((settings) => {
		if (settings && settings.Settings) {
			if (typeof settings.Settings === 'string') {
			this.productMappingDataGridSetting = JSON.parse(settings.Settings);
			} else {
			this.productMappingDataGridSetting = settings.Settings;
			}
		} else {
			this.productMappingDataGridSettings.Settings = JSON.stringify({autosave: true});
			this.updateGridSettings(this.productMappingDataGridSettings);
		}
		this.loadProductMappingDataGridState();
		});
	  this.loadColumnHeaderFilterData();
  }

  private loadProductMappingDataGridState() {
	const productMappingDataGridState: GridState = {
		PageName: this.pageName,
		GridName: this.mappingGridName,
		OwnedByUserId: this.currentUser.UserId
	};
	this.userService.getGridState(productMappingDataGridState)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((state) => {
		if (state) {
			this.currentProductMappingDataGridState = state;
		} else {
			this.currentProductMappingDataGridState = {
			PageName: this.pageName,
			GridName: this.mappingGridName,
			OwnedByUserId: this.currentUser.UserId,
			State: null
			};
		}
		this.loadProductMappingGridDataSource();
		});
  }

  public loadMappingState = () => {
	  if (this.isModal && this.cleanBarcode) {
			return;
	  }
		return this.currentProductMappingDataGridState.State ? JSON.parse(this.currentProductMappingDataGridState.State) : null;
  }

  public saveMappingState = (state) => {
	if (this.isModal && this.cleanBarcode) {
		return;
	}
	if (this.productMappingDataGridSetting) {
		let gridSetting: GridSetting;
		if (typeof this.productMappingDataGridSetting === 'string') {
		gridSetting = JSON.parse(this.productMappingDataGridSetting);
		} else {
		gridSetting = this.productMappingDataGridSetting;
		}
		if (gridSetting.autosave) {
		this.currentProductMappingDataGridState.State = JSON.stringify(state);
		this.updateGridState(this.currentProductMappingDataGridState);
		}
	}
  }

  private loadProductMappingGridDataSource() {
	this.isProductMappingDataGridSettingLoading = false;
	this.productMappingDataSource = new CustomStore({
		key: 'ServiceAndProductMappingId',
		load: (loadOptions: any) => {
		this.loaderService.show();
		this.isProductMappingDataLoading = true;
		let filter = this.formatFilterOperators(loadOptions.filter);
		const finalOptions: LoadOptions = loadOptions;
		if (this.isModal && this.cleanBarcode) {
		this.productMappingDataGrid.instance.clearFilter();
		filter = [];
		filter.push({operation: '=', column: 'CleanBarcode', condition: 'and', value: this.cleanBarcode, type: 'string' });
		}
		finalOptions.filter = filter;
		finalOptions.extraParams = this.extraFilteringOptions;
		this.productMappingLoadingOptions = finalOptions;
		return this.productMappingService.getProductMappingGrid(finalOptions)
			.toPromise()
			.then((data: any) => {
			this.isProductMappingDataLoading = false;
			this.loaderHandler();
			if (this.productMappingSelectedRowData) {
				const matchedData = data.data.find(item =>
					item.ServiceAndProductMappingId === this.productMappingSelectedRowData.ServiceAndProductMappingId);
				this.isMoveToNextRow = matchedData ? true : false;
			}
			if (!data.data || data.data.length === 0) {
				this.productToMasterData = [];
			}
			return {
				data: data.data,
				totalCount: data.totalCount,
				summary: data.summary,
				groupCount: data.groupCount
			};
			})
			.catch(error => {
			this.isProductMappingDataLoading = false;
			this.loaderHandler();
			throw new Error('Data Loading Error');
			});
		},
	}, );
	this.isLoadProductMappingGridDataSource = true;
  }

  private updateGridSettings(gridSettings: GridSettings) {
	gridSettings.SavedOn = new Date();
  this.userService.setGridSettings(gridSettings).pipe(take(1)).subscribe();
}

  private updateGridState(gridState: GridState) {
	gridState.SavedOn = new Date();
	this.userService.setGridState(gridState).pipe(take(1)).subscribe();
  }

  getHeaderFiltersProductMapping(loadingOption) {
	return this.productMappingService.getHeaderFiltersProductMapping(loadingOption)
		.toPromise()
		.catch(error => { throw new Error('Data Loading Error'); });
  }

  /**
   * Context menu for Prooduct Mapping Data  grid, aka first grid
   * @param e
   */
  productMappingDataContextMenu(e) {
	e.event.stopPropagation();
	if (e.target === 'content') {
		// e.items can be undefined
		if (!e.items) { e.items = []; }

		// Add a custom menu item
		e.items.push(
		{
			text: 'Refresh',
			icon: 'refresh',
			onItemClick: () => {
			this.refreshMappingDataGrid();
			}
		},
		{
			text: 'Grid Settings',
			items: [
				{
					text: this.productMappingDataGridSetting.autosave ? 'Disable autosave' : 'Enable autosave',
					onItemClick: () => {
					this.productMappingDataGridSetting.autosave = !this.productMappingDataGridSetting.autosave;
					this.productMappingDataGridSettings.Settings = JSON.stringify(this.productMappingDataGridSetting);
					this.updateGridSettings(this.productMappingDataGridSettings);
					}
				},
				{
					text: 'Reset to Default',
					onItemClick: () => {
						this.userService.resetDataGridStateToDefault(this.mappingGridName, this.pageName, this.currentUser.UserId)
						.pipe(take(1))
						.subscribe(() => {
							location.reload();
						});
					}
				}
			]
		}
		);
	}
  }

  /**
   * Context menu for Product to Master grid, aka middle grid
   * @param event
   */
  productToMasterContextMenu(e) {
	if (e.target === 'content') {
		// e.items can be undefined
		if (!e.items) { e.items = []; }
		const rowData: ProductMappingToMasterGridResult = e.row.data;
		// Add a custom menu item
		e.items.push(
		{
			text: 'Refresh',
			icon: 'refresh',
			onItemClick: () => {
			this.refreshProductToMasterGrid(rowData.ServiceAndProductMappingId);
			}
		},
		{
			text: 'Barcode Mapping',
			visible: (rowData.MappingSource === 'Barcode Mapping'),
			items: [
			{
				text: 'Omit Barcode',
				hint: 'Set this barcode as being omitted.',
				disabled: !(rowData.Ranking === 0 && rowData.CurrentMappingModeId === MappingMode.Omitted &&
					rowData.MappingModeId !== MappingMode.Omitted),
				onItemClick: () => {
				this.omitBarcode();
				},
			},
			{
				text: 'Save Barcode',
				hint: 'Save this barcode for mapping at some later point in time.',
				disabled: !(rowData.Ranking === 0 && rowData.CurrentMappingModeId === MappingMode.Saved && rowData.MappingModeId !== MappingMode.Saved),
				onItemClick: () => {
				this.saveBarcode();
				},
			},
			{
				text: 'Verify and Map Barcode',
				hint: 'Verify and map this barcode to the Product Master of the Current Mapping.',
				disabled: !(rowData.Ranking === 0 &&
				rowData.CurrentMappingModeId === MappingMode.Mapped &&
				rowData.MappingModeId !== MappingMode.Mapped &&
				rowData.IsValidBarcode &&
				!rowData.IsVerifiedBarcode &&
				rowData.CurrentProductMasterId !== 0 &&
				rowData.CurrentProductMasterId !== rowData.ProductMasterId),
				onItemClick: () => {
					this.createOrModifyBarcode(rowData);
				},
			},
			{
				text: 'Re-map Verified Barcode',
				hint: 'Correct (re-map) wrong mapping of this verified barcode to the Product Master of the Current Mapping.',
				disabled: !(rowData.Ranking === 0 &&
				rowData.CurrentMappingModeId === MappingMode.Mapped &&
				rowData.MappingModeId === MappingMode.Mapped &&
				rowData.IsValidBarcode &&
				rowData.IsVerifiedBarcode &&
				rowData.CurrentProductMasterId !== 0 &&
				rowData.CurrentProductMasterId !== rowData.ProductMasterId),
				onItemClick: () => {
				this.createOrModifyBarcode(rowData);
				},
			}
			]
		}
		);
	}
  }

  customizeProductMappingId(cellInfo) {
	return 'SeAPMp_' + cellInfo.value;
  }

  customizeProductMasterId(cellInfo) {
	return 'PMs_' + cellInfo.value;
  }

  dateTimeFieldCustomization(cellInfo) {
	const value = cellInfo.value;
	const date = moment(value, 'd/M/yyyy, HH:mm', true).isValid();
	const minDate = moment.utc('0001-01-01');

	if (date && moment.utc(value).isAfter(minDate)) {
		return cellInfo.valueText;
	} else {
		return '';
	}

	// if(cellInfo.target === "filterRow" && value) {
	//   return (value.getMonth() + 1) + "/" + value.getDate() + "/" + value.getFullYear();
	// }
  }

  formatFilterOperators(rawFilter: any[]) {
	if (!rawFilter) {
		return null;
	}
	const filterData = this.filterBuilder.handleNotFilterFormatting(rawFilter);
	return this.filterBuilder.filterFormatting(filterData);
  }

  extraFilteringOptionsChange(columnName, event) {
	if (event) {
		const option = this.extraFilteringOptions.find(item => item.column === columnName);
		option.value = event.value;
		this.productMappingDataGrid.instance.deselectAll();
		this.refreshMappingDataGrid();
	}
  }

  onReady(e) {
	const grid = e.component;
	const selection = grid.getSelectedRowKeys();
	if (this.productMappingSelectedRowData) {
		const currentDataItems = this.productMappingDataGrid.instance.getDataSource().items();
		const isSelectedRowExists = currentDataItems.find(item =>
		item.ServiceAndProductMappingId ===
		this.productMappingSelectedRowData.ServiceAndProductMappingId
		);
		if (!isSelectedRowExists && this.mappingDataGridCurrentPage !== this.productMappingDataGrid.instance.pageIndex()) {
		grid.selectRowsByIndexes([0]);
		}
	}
	if (selection.length === 0) {
		grid.selectRowsByIndexes([0]);
	} else {
		if (this.isMoveToNextRow && this.isNextRowAvailable) {
		this.moveToNextRow();
		this.isMoveToNextRow = false;
		} else {
		this.stayInRow();
		}
		if (this.mappingDataGridCurrentPage) {
		this.isMoveToNextRow = false;
		if (this.mappingDataGridCurrentPage !== this.productMappingDataGrid.instance.pageIndex()) {
			// this.productMappingDataGrid.instance.pageIndex(this.mappingDataGridCurrentPage);
		}
		}
	}
  }

  getProductMappingToMasterGridResult(serviceAndProductMappingId: number) {
	if (!serviceAndProductMappingId) {
		return;
	}
	this.isProductToMasterGridDataLoading = true;
	this.loaderService.show();
	this.productMappingService.getProductMappingToMasterGridResult(serviceAndProductMappingId)
		.pipe(
		takeUntil(this._destroyed$)
		)
		.subscribe((res: ProductMappingToMasterGridResult[]) => {
		this.isProductToMasterGridDataLoading = false;
		this.loaderHandler();

		this.productToMasterData = res;
		this.productToMasterGrid.instance.option('dataSource', res);
		});
  }

  selectionChangedHandler() {
	if (this.productMappingDataGrid.instance.getSelectedRowsData()[0]) {
		this.productMappingSelectedRowData = this.productMappingDataGrid.instance.getSelectedRowsData()[0];
		const serviceAndProductMappingId = this.productMappingSelectedRowData.ServiceAndProductMappingId;
		if (serviceAndProductMappingId) {
		this.getProductMappingToMasterGridResult(serviceAndProductMappingId);
		}
		this.setProductMappingSelectedRowIndex();
	}
  }

  productMappingSelectionChanged(selectedMasterGridRow) {
	this.selectedMasterGridRow = selectedMasterGridRow;
  }

  clear() {
	const mappingData: ProductMappingOption = {};
	mappingData.MappingModeId = MappingMode.New;
	mappingData.ModifiedByUserId = this.currentUser.UserId;
	mappingData.ServiceAndProductMappingId = this.productMappingSelectedRowData.ServiceAndProductMappingId;
	mappingData.ActionType = MappingAction.Clear;
	this.productMappingService.mappingAction(mappingData)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res) => {
		if (res) {
			this.isMoveToNextRow = res.MoveToNextRow;
			this.refreshMappingDataGrid();
			this.notificationService.show('Cleared successfully!', NotificationType.Success);
		} else {
			this.notificationService.show('Something went wrong', NotificationType.Error);
		}
		});
  }

  omit() {
	const mappingData: ProductMappingOption = {};
	mappingData.MappingModeId = MappingMode.Omitted;
	mappingData.ModifiedByUserId = this.currentUser.UserId;
	mappingData.ServiceAndProductMappingId = this.productMappingSelectedRowData.ServiceAndProductMappingId;
	mappingData.ActionType = MappingAction.Omit;
	this.productMappingService.mappingAction(mappingData)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res) => {
		if (res) {
			this.isMoveToNextRow = res.MoveToNextRow;
			this.refreshMappingDataGrid();
			this.notificationService.show('Omitted successfully!', NotificationType.Success);
		} else {
			this.notificationService.show('Something went wrong', NotificationType.Error);
		}
		});
  }

  save() {
	const mappingData: ProductMappingOption = {};
	mappingData.MappingModeId = MappingMode.Saved;
	mappingData.ModifiedByUserId = this.currentUser.UserId;
	mappingData.ServiceAndProductMappingId = this.productMappingSelectedRowData.ServiceAndProductMappingId;
	mappingData.ActionType = MappingAction.Save;
	this.loaderService.show();
	this.productMappingService.mappingAction(mappingData)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res) => {
		if (res) {
			this.isMoveToNextRow = res.MoveToNextRow;
			this.refreshMappingDataGrid();
			this.notificationService.show('Accept saved successfully!', NotificationType.Success);
		} else {
			this.notificationService.show('Something went wrong', NotificationType.Error);
			this.loaderHandler();
		}
		});
  }

  map(productMasterId) {
	const mappingData: ProductMappingOption = {};
	mappingData.MappingModeId = MappingMode.Mapped;
	mappingData.ModifiedByUserId = this.currentUser.UserId;
	mappingData.ServiceAndProductMappingId = this.productMappingSelectedRowData.ServiceAndProductMappingId;
	mappingData.ProductMasterId = productMasterId;
	mappingData.ActionType = MappingAction.Map;
	this.loaderService.show();
	this.productMappingService.mappingAction(mappingData)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res) => {
		if (res) {
			this.refreshMappingDataGrid();
			this.notificationService.show('Mapped successfully!', NotificationType.Success);
		} else {
			this.notificationService.show('Something went wrong', NotificationType.Error);
			this.loaderHandler();
		}
		});
  }

  accept() {
	const mappingData: ProductMappingOption = {};
	mappingData.MappingModeId = MappingMode.Mapped;
	mappingData.ModifiedByUserId = this.currentUser.UserId;
	mappingData.ServiceAndProductMappingId = this.productMappingSelectedRowData.ServiceAndProductMappingId;
	mappingData.ActionType = MappingAction.Accept;
	this.loaderService.show();
	this.productMappingService.mappingAction(mappingData)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res) => {
		if (res) {
			this.isMoveToNextRow = res.MoveToNextRow;
			this.refreshMappingDataGrid();
			this.notificationService.show('Accepted successfully!', NotificationType.Success);
		} else {
			this.notificationService.show('Something went wrong', NotificationType.Error);
			this.loaderHandler();
		}
		});
  }

  review() {
	const mappingData: ProductMappingOption = {};
	mappingData.ModifiedByUserId = this.currentUser.UserId;
	mappingData.ServiceAndProductMappingId = this.productMappingSelectedRowData.ServiceAndProductMappingId;
	mappingData.ActionType = MappingAction.Review;
	this.loaderService.show();
	this.productMappingService.mappingAction(mappingData)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res) => {
		if (res) {
			this.isMoveToNextRow = res.MoveToNextRow;
			this.refreshMappingDataGrid();
			this.notificationService.show('Review successfully!', NotificationType.Success);
		} else {
			this.notificationService.show('Something went wrong', NotificationType.Error);
			this.loaderHandler();
		}
		});
  }

  acceptMapping(productMasterId) {
	const mappingData: ProductMappingOption = {};
	mappingData.MappingModeId = MappingMode.Mapped;
	mappingData.ModifiedByUserId = this.currentUser.UserId;
	mappingData.ServiceAndProductMappingId = this.productMappingSelectedRowData.ServiceAndProductMappingId;
	mappingData.ProductMasterId = productMasterId;
	mappingData.ActionType = MappingAction.AcceptMapping;
	this.loaderService.show();
	this.productMappingService.mappingAction(mappingData)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res) => {
		if (res) {
			this.isMoveToNextRow = res.MoveToNextRow;
			this.refreshMappingDataGrid();
			this.notificationService.show('Accept Mapping successfully!', NotificationType.Success);
		} else {
			this.notificationService.show('Something went wrong', NotificationType.Error);
			this.loaderHandler();
		}
		});
  }

  mapAsService() {
	const mappingData: ProductMappingOption = {};
	mappingData.MappingModeId = MappingMode.New;
	mappingData.MappingAsService = true;
	mappingData.ModifiedByUserId = this.currentUser.UserId;
	mappingData.ServiceAndProductMappingId = this.productMappingSelectedRowData.ServiceAndProductMappingId;
	mappingData.ActionType = MappingAction.MapAsService;
	this.loaderService.show();
	this.productMappingService.mappingAction(mappingData)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res) => {
		if (res) {
			this.isMoveToNextRow = res.MoveToNextRow;
			this.refreshMappingDataGrid();
			this.notificationService.show('Moved to Service successfully!', NotificationType.Success);
		} else {
			this.notificationService.show('Something went wrong', NotificationType.Error);
			this.loaderHandler();
		}
		});
  }

  deactivate(productMappingId) {
	const mappingData: ProductMappingOption = {};
	mappingData.ModifiedByUserId = this.currentUser.UserId;
	mappingData.Active = false;
	mappingData.ServiceAndProductMappingId = productMappingId;
	mappingData.ActionType = MappingAction.Deactivate;
	this.loaderService.show();
	this.productMappingService.mappingAction(mappingData)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res) => {
		if (res) {
			this.isMoveToNextRow = res.MoveToNextRow;
			this.refreshMappingDataGrid();
			this.notificationService.show('Deactivated successfully!', NotificationType.Success);
		} else {
			this.notificationService.show('Something went wrong', NotificationType.Error);
			this.loaderHandler();
		}
		});
  }

  reactivate(productMappingId) {
	const mappingData: ProductMappingOption = {};
	mappingData.ModifiedByUserId = this.currentUser.UserId;
	mappingData.Active = true;
	mappingData.ServiceAndProductMappingId = productMappingId;
	mappingData.ActionType = MappingAction.Reactivate;
	this.loaderService.show();
	this.productMappingService.mappingAction(mappingData)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res) => {
		if (res) {
			this.isMoveToNextRow = res.MoveToNextRow;
			this.refreshMappingDataGrid();
			this.notificationService.show('Reactivated successfully!', NotificationType.Success);
		} else {
			this.notificationService.show('Something went wrong', NotificationType.Error);
			this.loaderHandler();
		}
		});
  }

  omitBarcode() {
	const mappingData: ProductMappingOption = {};
	mappingData.MappingModeId = MappingMode.Omitted;
	mappingData.ModifiedByUserId = this.currentUser.UserId;
	mappingData.ServiceAndProductMappingId = this.productMappingSelectedRowData.ServiceAndProductMappingId;
	mappingData.ActionType = MappingAction.OmitBarcode;
	this.loaderService.show();
	this.productMappingService.mappingAction(mappingData)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res) => {
		if (res) {
			this.isMoveToNextRow = res.MoveToNextRow;
			this.refreshMappingDataGrid();
			this.notificationService.show('Barcode omitted!', NotificationType.Success);
		} else {
			this.notificationService.show('Something went wrong', NotificationType.Error);
			this.loaderHandler();
		}
		});
  }

  saveBarcode() {
	const mappingData: ProductMappingOption = {};
	mappingData.MappingModeId = MappingMode.Saved;
	mappingData.ModifiedByUserId = this.currentUser.UserId;
	mappingData.ServiceAndProductMappingId = this.productMappingSelectedRowData.ServiceAndProductMappingId;
	mappingData.ActionType = MappingAction.SaveBarcode;
	this.loaderService.show();
	this.productMappingService.mappingAction(mappingData)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res) => {
		if (res) {
			this.isMoveToNextRow = res.MoveToNextRow;
			this.refreshMappingDataGrid();
			this.notificationService.show('Barcode saved!', NotificationType.Success);
		} else {
			this.notificationService.show('Something went wrong', NotificationType.Error);
			this.loaderHandler();
		}
		});
  }

  createOrModifyBarcode(rowData: ProductMappingToMasterGridResult) {
	this.loaderService.show();
	let barcodeMappingOption: BarcodeMappingOption;
	const currentUserId = this.currentUser.UserId;
	barcodeMappingOption = rowData;
	barcodeMappingOption.CurrentUserId = currentUserId;
	const serviceAndProductMappingId = this.productMappingSelectedRowData.ServiceAndProductMappingId;
	this.productMappingService.createOrModifyBarcode(barcodeMappingOption)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res) => {
		if (res) {
			this.notificationService.show('Barcode verified and mapped', NotificationType.Success);
			this.isMoveToNextRow = res.MoveToNextRow;
			this.refreshMappingDataGrid();
			this.refreshProductToMasterGrid(serviceAndProductMappingId);
		} else {
			this.notificationService.show('Something went wrong', NotificationType.Error);
			this.loaderService.hide();
		}
		});
  }

  isEligibleForBarcodeMapping(rowData: ProductMappingToMasterGridResult) {
	if (rowData.Ranking === 0 && (
		(rowData.CurrentMappingModeId === MappingMode.Omitted && rowData.MappingModeId !== MappingMode.Omitted) ||
		(rowData.CurrentMappingModeId === MappingMode.Saved && rowData.MappingModeId !== MappingMode.Saved) ||
		(
			rowData.CurrentMappingModeId === MappingMode.Mapped &&
			rowData.MappingModeId !== MappingMode.Mapped &&
			rowData.IsValidBarcode &&
			!rowData.IsVerifiedBarcode &&
			rowData.CurrentProductMasterId !== 0 &&
			rowData.CurrentProductMasterId !== rowData.ProductMasterId
		)
		)) {
		return true;
	}
	return false;
  }

  onRowExpanding(e: any) {
		e.component.collapseAll(-1);
  }

	onRowExpanded(e: any) {
		e.component.selectRows([e.key]);
	}

  /**
   * Refresh Product mapping grid, aka first grid
   */
  refreshMappingDataGrid() {
	this.mappingDataGridCurrentPage = this.productMappingDataGrid.instance.pageIndex();
	this.productMappingDataGrid.instance.refresh().then(() => {
		this.productMappingDataGrid.instance.repaint();
		});
  }

  /**
   * Refresh Product master grid, aka middle grid
   */
  refreshProductToMasterGrid(serviceAndProductMappingId: number) {
		this.getProductMappingToMasterGridResult(serviceAndProductMappingId);
		this.productToMasterGrid.instance.refresh();
  }

  createProduct() {
	this.isCreateProduct = true;
  }

  private moveToNextRow() {
	this.setProductMappingSelectedRowIndex();
	this.productMappingDataGrid.instance.selectRowsByIndexes([this.productMappingSelectedRowIndex + 1]);
  }

  private stayInRow() {
	this.setProductMappingSelectedRowIndex();
	this.productMappingDataGrid.instance.selectRowsByIndexes([this.productMappingSelectedRowIndex]);
  }

  private setProductMappingSelectedRowIndex() {
	const selectedRowKey = this.productMappingSelectedRowData.ServiceAndProductMappingId;
	const productMappingSelectedRowIndex = this.productMappingDataGrid.instance.getRowIndexByKey(selectedRowKey);
	this.productMappingSelectedRowIndex = productMappingSelectedRowIndex >= 0 ?
		productMappingSelectedRowIndex : this.productMappingSelectedRowIndex;
  }

  private get isNextRowAvailable() {
	const productMappingRowData = this.productMappingDataGrid.instance.getRowElement(this.productMappingSelectedRowIndex + 1);
	if (productMappingRowData) {
		return true;
	}

	return false;
  }

  private loaderHandler() {
	if (
		!this.isProductMappingDataLoading &&
		!this.isProductToMasterGridDataLoading &&
		!this.isProductMasterDataLoading &&
		!this.isProductMappingDataGridSettingLoading) {
		this.loaderService.hide();
	}
  }



	private loadColumnHeaderFilterData() {

		this.mappingAssignedHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				loadOptions.column = 'MappingAssignedToUserFullNameSortableOrPrincipalName';
				loadOptions.valueColumn = '';

				return this.getHeaderFiltersProductMapping(loadOptions);
			}
		});


	this.modifiedByHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ModifiedByUserFullNameSortableOrPrincipalName';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersProductMapping(loadOptions);
		}
	});

	this.reviewedByHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ReviewedByUserFullNameSortableOrPrincipalName';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersProductMapping(loadOptions);
		}
	});

	this.createdByHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CreatedByUserFullNameSortableOrPrincipalName';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersProductMapping(loadOptions);
		}
	});

	this.masterBrandNameMappingHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'MasterBrandName';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersProductMapping(loadOptions);
		}
	});

	this.brandNameMappingHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'BrandName';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersProductMapping(loadOptions);
		}
	});

	this.companyNameMappingHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CompanyName';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersProductMapping(loadOptions);
		}
	});

	this.categoryNameMappingHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CategoryName';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersProductMapping(loadOptions);
		}
	});

	this.mappingPriorityHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'MappingPriority';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersProductMapping(loadOptions);
		}
	});

	this.mappingModeNameHeaderDataSource = [
		{
		text: 'New',
		value: 0
		},
		{
		text: 'Map',
		value: 1
		},
		{
		text: 'Save',
		value: 2
		},
		{
		text: 'Omit',
		value: 2
		}
	];

	this.modifiedOnHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ModifiedOn';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersProductMapping(loadOptions);
		}
	});

	this.reviewedOnHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ReviewedOn';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersProductMapping(loadOptions);
		}
	});

	this.createdOnHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CreatedOn';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersProductMapping(loadOptions);
		}
	});
  }

  ngOnDestroy() {
	this.dragulaService.destroy('HANDLES');
	this._destroyed$.next(null);
	this._destroyed$.complete();
	this._editCanceled$.next(null);
	this._editCanceled$.unsubscribe();
  }

	productMasterGridLoadingHandler(state: boolean) {
		this.isProductMasterDataLoading = state;
		this.loaderHandler();
	}
}
